import { Schemas } from 'services/ArtboardConverter/models';

export const createBoxModel = ({
  padding = '0',
  margin = '0',
} = {} as Partial<Schemas.BoxModel>): Schemas.BoxModel => ({
  padding: String(padding),
  margin: String(margin),
});
